var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLargeBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bank Transfer (ACH)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1533",
    d: "M12.7536 116.73H129.5L135.5 135.238H5.7536L12.7536 116.73Z",
    fill: "url(#paint0_linear_2512_7589)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M95 52.2632V51.7632H94.5H47.5H47V52.2632V94.2632V94.7632H47.5H94.5H95V94.2632V52.2632Z",
    fill: "url(#paint1_linear_2512_7589)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M80.5 94.2632V76.2632C80.5 71.2926 76.4706 67.2632 71.5 67.2632C66.5294 67.2632 62.5 71.2926 62.5 76.2632V94.2632H80.5Z",
    fill: "url(#paint2_linear_2512_7589)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M80.5 94.2632V76.2632C80.5 71.2926 76.4706 67.2632 71.5 67.2632V67.2632C66.5294 67.2632 62.5 71.2926 62.5 76.2632V94.2632",
    stroke: "#0E5CF4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M39 53.2632V52.7632H38.5H29.5H29V53.2632V94.2632V94.7632H29.5H38.5H39V94.2632V53.2632Z",
    fill: "url(#paint3_linear_2512_7589)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M113 53.2632V52.7632H112.5H103.5H103V53.2632V94.2632V94.7632H103.5H112.5H113V94.2632V53.2632Z",
    fill: "url(#paint4_linear_2512_7589)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M117 52.2632V51.7632H116.5H99.5H99V52.2632V55.2632V55.7632H99.5H116.5H117V55.2632V52.2632Z",
    fill: "url(#paint5_linear_2512_7589)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M43 52.2632V51.7632H42.5H25.5H25V52.2632V55.2632V55.7632H25.5H42.5H43V55.2632V52.2632Z",
    fill: "url(#paint6_linear_2512_7589)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M115 56.2632V55.7632H114.5H101.5H101V56.2632V59.2632V59.7632H101.5H114.5H115V59.2632V56.2632Z",
    fill: "url(#paint7_linear_2512_7589)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M41 56.2632V55.7632H40.5H27.5H27V56.2632V59.2632V59.7632H27.5H40.5H41V59.2632V56.2632Z",
    fill: "url(#paint8_linear_2512_7589)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M125 45.2975C125 45.1489 124.934 45.0079 124.82 44.9129L73.0742 1.92104C72.1612 1.1625 70.8407 1.15052 69.9141 1.89238L16.1875 44.9072C16.069 45.0021 16 45.1457 16 45.2975V51.2632C16 51.5393 16.2239 51.7632 16.5 51.7632H124.5C124.776 51.7632 125 51.5393 125 51.2632V45.2975Z",
    fill: "url(#paint9_linear_2512_7589)",
    stroke: "white",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 115",
    cx: 71.5,
    cy: 34.2632,
    r: 11,
    fill: "#F6F7FA",
    stroke: "#0E5CF4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M71.5 28.6632C69.567 28.6632 68 29.9168 68 31.4632C68 33.0096 69.1667 34.2632 71.5 34.2632C73.8333 34.2632 75 35.5168 75 37.0632C75 38.6096 73.433 39.8632 71.5 39.8632M71.5 28.6632C72.7955 28.6632 73.9266 29.2263 74.5317 30.0632M71.5 28.6632V27.2632M71.5 39.8632L71.5 41.2632M71.5 39.8632C70.2045 39.8632 69.0734 39.3001 68.4683 38.4632",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M20.2764 116.763H20.5067L20.6564 116.588L33.88 101.125L34 100.984V100.8C34 97.0351 33.4936 94.3502 32.5528 92.4225C31.6585 90.5901 30.3849 89.4691 28.8527 88.7589C28.7376 86.912 27.6608 85.4315 26.1432 84.4159C24.5421 83.3443 22.42 82.7632 20.2764 82.7632C18.0225 82.7632 15.2064 84.3256 13.4949 86.6523C12.63 87.8282 12.0264 89.2251 11.9257 90.7529C11.8384 92.0786 12.1317 93.4777 12.9267 94.8858C11.0481 95.2367 9.70017 96.0502 8.75833 97.1236C7.70119 98.3285 7.19262 99.8183 6.97364 101.235C6.75451 102.654 6.82032 104.03 6.93815 105.045C6.99523 105.537 7.06497 105.948 7.12215 106.243C5.23209 106.692 3.88345 107.488 2.94068 108.469C1.91893 109.532 1.40518 110.78 1.17131 111.955C0.938063 113.126 0.980557 114.235 1.07863 115.045C1.12784 115.452 1.19153 115.788 1.24343 116.023C1.2694 116.141 1.29248 116.234 1.30942 116.299C1.31789 116.332 1.32483 116.357 1.32984 116.375L1.33585 116.396L1.33768 116.402L1.33828 116.404L1.3385 116.405C1.33859 116.405 1.33867 116.406 1.81794 116.263L1.33867 116.406L1.44495 116.763H1.81794H20.2764Z",
    fill: "url(#paint10_linear_2512_7589)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1531",
    x: -0.5,
    y: 0.5,
    width: 117,
    height: 11,
    transform: "matrix(1 0 0 -1 13.5 117.263)",
    fill: "url(#paint11_linear_2512_7589)",
    stroke: "white",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1532",
    x: -0.5,
    y: 0.5,
    width: 101,
    height: 11,
    transform: "matrix(1 0 0 -1 21.5 106.263)",
    fill: "url(#paint12_linear_2512_7589)",
    stroke: "white",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2512_7589",
    x1: 70.6268,
    y1: 116.73,
    x2: 70.6268,
    y2: 135.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F7FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2512_7589",
    x1: 71,
    y1: 33.8327,
    x2: 71,
    y2: 94.2632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2512_7589",
    x1: 38.622,
    y1: 58.4169,
    x2: 81.6445,
    y2: 95.6549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E5CF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2512_7589",
    x1: 34,
    y1: 33.8327,
    x2: 34,
    y2: 94.2632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2512_7589",
    x1: 108,
    y1: 33.8327,
    x2: 108,
    y2: 94.2632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2512_7589",
    x1: 108,
    y1: 50.8414,
    x2: 108,
    y2: 55.2632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2512_7589",
    x1: 34,
    y1: 50.8414,
    x2: 34,
    y2: 55.2632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2512_7589",
    x1: 108,
    y1: 54.8414,
    x2: 108,
    y2: 59.2632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2512_7589",
    x1: 34,
    y1: 54.8414,
    x2: 34,
    y2: 59.2632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2512_7589",
    x1: 71.5,
    y1: -22.4326,
    x2: 71.5,
    y2: 51.2632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2512_7589",
    x1: 31.8556,
    y1: 83.2632,
    x2: 1.30626,
    y2: 116.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E5CF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2512_7589",
    x1: 58,
    y1: -4.73915,
    x2: 58,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE2EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2512_7589",
    x1: 50,
    y1: -4.73915,
    x2: 50,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2EB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLargeBank);
export default __webpack_public_path__ + "static/media/ic-large-bank.11d53d16af8befb271416dcd6727c6fa.svg";
export { ForwardRef as ReactComponent };